import { StandardEvents } from '@shopify/events';

const ACTION_SELECTOR = '.celirae-card-action[data-celirae-product-id]';
let productIdsInCart = new Set();
let syncPromise = null;

function applyCartState(root = document) {
  root.querySelectorAll(ACTION_SELECTOR).forEach((action) => {
    const productId = String(action.dataset.celiraeProductId || '');
    const inCart = productIdsInCart.has(productId);
    const addAction = action.querySelector('[data-celirae-add]');
    const viewAction = action.querySelector('[data-celirae-view]');

    if (addAction instanceof HTMLElement) addAction.hidden = inCart;
    if (viewAction instanceof HTMLElement) viewAction.hidden = !inCart;
  });
}

async function syncCollectionCardActions() {
  if (syncPromise) return syncPromise;

  const root = window.Shopify?.routes?.root || '/';
  syncPromise = fetch(`${root}cart.js`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Unable to read cart: ${response.status}`);
      return response.json();
    })
    .then((cart) => {
      productIdsInCart = new Set((cart.items || []).map((item) => String(item.product_id)));
      applyCartState();
    })
    .catch((error) => {
      console.warn('[CELI RAE collection cards] Cart sync failed:', error);
    })
    .finally(() => {
      syncPromise = null;
    });

  return syncPromise;
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const updatePromise = event.promise || Promise.resolve();

  updatePromise
    .then(({ detail } = {}) => {
      if (detail?.didError) return;
      return syncCollectionCardActions();
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') {
        console.warn('[CELI RAE collection cards] Cart update failed:', error);
      }
    });
});

document.addEventListener('shopify:section:load', () => {
  syncCollectionCardActions();
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;

      if (node.matches(ACTION_SELECTOR)) {
        applyCartState(node.parentElement || document);
      } else if (node.querySelector(ACTION_SELECTOR)) {
        applyCartState(node);
      }
    }
  }
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncCollectionCardActions, { once: true });
} else {
  syncCollectionCardActions();
}
